import { usePathname, useSearchParams } from 'next/navigation';
import { useAppRouter } from './useAppRouter';

export const useURLQuery = () => {
  const searchParams = useSearchParams();
  const pathname = usePathname();
  const router = useAppRouter();
  const params = new URLSearchParams(searchParams.toString());

  const get = (key: string) => {
    return searchParams.get(key);
  };

  const set = (key: string, value: string) => {
    params.set(key, value);
    router.push(`${pathname}?${params.toString()}`);
  };

  const setMultiple = (records: Record<string, string>) => {
    Object.entries(records).forEach(([key, value]) => {
      params.set(key, value);
    });
    router.push(`${pathname}?${params.toString()}`);
  };

  const remove = (key: string) => {
    params.delete(key);
    router.push(`${pathname}?${params.toString()}`);
  };
  const removeMultiple = (keys: string[]) => {
    keys.forEach((key) => {
      params.delete(key);
    });
    router.push(`${pathname}?${params.toString()}`);
  };

  const getAll = () => {
    return params.toString();
  };

  const query = {
    get,
    set,
    setMultiple,
    remove,
    removeMultiple,
    getAll,
  };

  return query;
};
